import { useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { useQueryClient } from 'react-query';
import { trackLogout } from 'analytics/ga4';
import { clearAuthSession } from 'utils/clearAuthSession';

export default function ExitPage () {

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {

    trackLogout();
    clearAuthSession();
    queryClient.removeQueries({ queryKey: ['getAccountInfo'] });
    navigate("/");

  }, [navigate, queryClient])

  return (<></>)

}
